import { useContext } from 'react'

import { AuthContext, AuthContextInterface } from './auth.context'

export const useAuth = (): AuthContextInterface => {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error(`useAuth must be used within an AuthProvider`)
  }
  return context
}
